import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * URL paramlarni ishonchli olish:
 * - query (?customerId=..)
 * - hash (#customerId=.. yoki #/?customerId=..)
 * - Telegram WebApp start_param (agar mavjud bo‘lsa)
 */
export function useAppParams() {
    const [sp] = useSearchParams();

    const params = useMemo(() => {
        // 1) QUERY
        const query = new URLSearchParams(
            typeof window !== 'undefined' ? window.location.search : ''
        );

        // 2) HASH
        //    Routerlar ba’zida "#/?customerId=..." formatida ham bo‘ladi — boshidagi "#/?" ni tozalaymiz
        const hashRaw =
            typeof window !== 'undefined'
                ? window.location.hash.replace(/^#\/?/, '')
                : '';
        const hash = new URLSearchParams(hashRaw);

        // 3) Telegram WebApp (ichida ochilganda)
        let tgParams = new URLSearchParams();
        try {
            const tg = window?.Telegram?.WebApp;
            const startParam =
                tg?.initDataUnsafe?.start_param || tg?.initDataUnsafe?.startapp;
            // startParam ni "customerId=..&branchId=..&businessId=.." ko‘rinishida yuborish mumkin
            if (startParam && typeof startParam === 'string') {
                // Agar base64 bo‘lsa, decode qilib ko‘rishingiz ham mumkin:
                // try { const decoded = atob(startParam); tgParams = new URLSearchParams(decoded); } catch {}
                tgParams = new URLSearchParams(startParam);
            }
        } catch {
            /* ignore */
        }

        // Tartib: react-router (sp) -> query -> hash -> telegram
        const get = (k) => sp.get(k) || query.get(k) || hash.get(k) || tgParams.get(k);

        return {
            customerId: get('customerId') || '',
            branchId: get('branchId') || '',
            businessId: get('businessId') || '',
        };
    }, [sp]);

    return params;
}
